import React, { useEffect, useState } from 'react';

import {
	DeliverSuccessfull,
	DeliveryErrorMessages,
} from '../../components/common/AllConfirmationMessages';

import { PatientDetails } from '../../components/common/patientDetails';

import { onhandleConfirmDelivery } from '../../utils/helper/deliveriesHelper';

import {
	RouteConfirmation,
	PharmacistConfirmationModal
} from '../../components/common/routeConfirmation';

import {
	apiKey,
	deliveryDriverDeliveredDispense
} from '../../networking/urlEndPoints';

import {
	clearAllTodayDispenseData,
	removeTodayDispenePatientById,
	todayDispenseRemovingPageNumber
} from '../../services/slices/dispense/patientForRouteList';

import { fetchPatientlistOnBasisOfRoute } from '../../services/apis/dispense/patientsForRouteLIst';
import { fetchPharmacistOfPharmacy } from '../../services/apis/dispense/pharmacistOfPharmacy';
import { fetchPharmacyDetails } from '../../services/apis/dispense/getPharmacyDetail';
import { useAllSelector } from '../../services/selectors/allSelector';

import { LoadingView } from '../../components/common/loader';
import { ErrorMessages } from '../../components/error/errorMessages';

import { DispenseRxData } from '../../components/common/dispenseRxData';
import {
	handleToggleRXData,
} from '../../utils/helper/helper';
import { useCustomStates } from '../../hooks/useCustomStates';

import { useAuthSelector } from '../../services/selectors/authSelector';
import { RoutePharmacistModal } from '../../components/common/routePharmacistModal';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';

import { clearSelectedPharmacistID } from '../../services/slices/auth/selectedPharmacist';
import { TodayDispenseDeliveredByAnotherDriverAblyHelper } from '../../utils/helper/ablyDeliveredDispenseByOthers';
import { PharmacistSelection } from '../../components/common/pharmacistSelection';
import {
	InstoreDeliveryAssignmentAlert,
	InstoreDeliveryStockDecisionModal,
} from '../../components/common/instoreDeliveryContinuation';
import InstoreUnassignedHandover from '../../components/common/InstoreUnassignedHandover';

import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBox from '../../components/common/searchBox';

import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import * as routeName from '../../routes/routeName';

const TodayDispense = () => {

	const location = Hooks.useCustomLocation()
	const dispatch = Hooks.useCustomDispatch();
	const navigate = Hooks.useCustomNavigate();

	const {
		pharmacyId,
		pharmacyDetailResponse,
		selectedPharmacistID,
		driverID,
		pharmacyInspectionMode,
		instoreDefaultRoute } = useAuthSelector()


	const {
		patientDataBasisOfRouteResponse,
		todaysDispenseList,
		validateReturnedPatchesResponse,
		pharmacistOfPharmacyListResponse,
		routeListResponse,
		pharmacistDetail,
	} = useAllSelector();


	const { comment,
		setComment,

		cordinate,
		setCordinate,

		openIndex,
		setOpenIndex,

		isRefused,
		setIsRefused,

		patientSignature,
		setPatientSignature,

		pharmacistSignature,
		setPharmacistSignature,

		showErrorToast,
		setShowErrorToast,

		loading,
		setLoading,

		showSuccessToast,
		setShowSuccessToast,

		showComment,
		setShowComment,

		showPatientSignature,
		setShowPatientSignature,

		showPharmacistSignature,
		setShowPharmacistSignature,

		showData,
		setShowData,

		apiCallMade,
		setApiCallMade,

		showToast,
		setShowToast,

		showConfirmationModal,
		setShowConfirmationModal,

		setMissedDeliveryErrorToast,
		missedDeliverErrorToast,

		signatureErrors,
		setSignatureErrors,

		covid19,
		setCovid19,

		selectedRoute,
		setSelectedRoute,

		isTransferRequest,
		setIsTransferRequest,

		loadMore,
		setLoadMore,

		delveryDoneByAnotherDriver,
		setDeliveryDoneByAnotherDriver,

		patientId,
		setPatientID,

		pId,
		setPId,

		showModel,
		setShowModel,

		consultation,
		setConsultation,

		newRxCounsellingValues,
		setNewRxCounsellingValues,

		isPatientVerified,
		setIsPatientVerified,

		selectedDoses,
		setSelectedDoses,

		showPharmacistConfirmation,
		setShowPharmacistConfirmation,

		pendingDeliveryData,
		setPendingDeliveryData,

		pendingDeliveryIndex,
		setPendingDeliveryIndex

	} = useCustomStates()

	const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([])
	const [showFlexiConfirmation, setShowFlexiConfirmation] = useState(false)
	const [flexiProofImages, setFlexiProofImages] = useState({})
	const [copayPaymentOptions, setCopayPaymentOptions] = useState({})
	const [showStockDecisionModal, setShowStockDecisionModal] = useState(false)
	const [pendingStockDecision, setPendingStockDecision] = useState(null)

	// ----------------------------#Get Selected Pharmacist Name----------------

	const getSelectedPharmacistName = () => {
		if (selectedPharmacistID && pharmacistDetail?.length) {
			const selectedPharmacist = pharmacistDetail.find(
				pharmacist => Number(pharmacist.id) === Number(selectedPharmacistID) || pharmacist.id == selectedPharmacistID
			);
			return selectedPharmacist?.name || '';
		}
		return '';
	};

	// ----------------------------#DropDown RX DATA----------------

	const handleDropdownToggle = (index, data) => {
		setConsultation(null)
		setNewRxCounsellingValues([])
		setSelectedDoses({})
		if (openIndex !== index) {
			const rxIds = data?.patients_win_rx_data?.map((r) => r.id).filter(Boolean) || []
			setSelectedDeliverRxIds(rxIds)
		}
		handleToggleRXData(
			index,
			data,
			openIndex,
			setOpenIndex,
			dispatch,
			clearSelectedPharmacistID,
			setSignatureErrors,
			setShowData,
			RemoveAllPatchesId,
			setPatientSignature,
			setShowComment,
			setShowPatientSignature,
			setShowPharmacistSignature,
			setPharmacistSignature,
			setComment,
			setIsPatientVerified,
			setPId,
			pharmacyId
		);
	};

	// ---------------------------Pickup BY-DEFAULT Route----------------

	useEffect(() => {
		if (instoreDefaultRoute && pharmacyId && !apiCallMade) {
			const params = {
				route: instoreDefaultRoute,
				pharmacy_id: pharmacyId,
				setLoading: setLoading,
			}
			dispatch(clearAllTodayDispenseData())
			dispatch(todayDispenseRemovingPageNumber())
			setLoading(true)
			dispatch(fetchPatientlistOnBasisOfRoute(params))
			setApiCallMade(true)
		}

		return () => { }
	}, [apiCallMade, dispatch, instoreDefaultRoute, pharmacyId, setApiCallMade, setLoading])

	useEffect(() => {
		if (!pharmacyId) {
			return () => { }
		}

		if (!pharmacyDetailResponse?.loading && !pharmacyDetailResponse?.data) {
			dispatch(fetchPharmacyDetails(pharmacyId))
		}

		if (!pharmacistOfPharmacyListResponse?.loading && !pharmacistOfPharmacyListResponse?.data) {
			dispatch(fetchPharmacistOfPharmacy(pharmacyId))
		}

		return () => { }
	}, [
		dispatch,
		pharmacistOfPharmacyListResponse?.data,
		pharmacistOfPharmacyListResponse?.loading,
		pharmacyDetailResponse?.data,
		pharmacyDetailResponse?.loading,
		pharmacyId,
	])

	useEffect(() => {
		if (routeListResponse?.includes(instoreDefaultRoute)) {
			setSelectedRoute(instoreDefaultRoute)
		} else {
			setSelectedRoute('')
		}
		return () => { }
	}, [instoreDefaultRoute, routeListResponse])

	// ---------------------------Pickup BYDEfault Route----------------

	const handleConfirmDelivery = (patientData, index) => {
		// if (!isRefused && (!patientSignature || patientSignature[0] == null)) {
		// 	setSignatureErrors(prevState => ({ ...prevState, patientSign: '1px solid red' }));
		// 	return;
		// }
		setPendingDeliveryData(patientData);
		setPendingDeliveryIndex(index);
		// Only show Confirm Pharmacist popup when there is a pharmacist signature on the pad
		if (pharmacistSignature) {
			setShowPharmacistConfirmation(true);
		} else {
			// No pharmacist sign – continue delivery without showing the modal
			requestStockDecisionOrProceed(patientData, index);
			setPendingDeliveryData(null);
			setPendingDeliveryIndex(null);
		}
	}

	const proceedWithDelivery = () => {
		setShowPharmacistConfirmation(false);
		if (pendingDeliveryData && pendingDeliveryIndex !== null) {
			requestStockDecisionOrProceed(pendingDeliveryData, pendingDeliveryIndex)
		}
		setPendingDeliveryData(null);
		setPendingDeliveryIndex(null);
	}

	const processDelivery = (patientData, index, deliveryStockDisposition = null, deliveryStockSignature = null) => {
		onhandleConfirmDelivery(patientData,
			index,
			pharmacyId,
			selectedPharmacistID,
			patientSignature,
			pharmacistSignature,
			cordinate,
			comment,
			dispatch,
			setLoading,
			setOpenIndex,
			setShowErrorToast,
			setShowSuccessToast,
			pharmacyInspectionMode,
			isRefused,
			covid19,
			'today_dispense',
			setIsRefused,
			setSignatureErrors,
			validateReturnedPatchesResponse,
			isTransferRequest,
			setIsTransferRequest,
			consultation,
			newRxCounsellingValues,
			selectedDoses,
			{},
			{},
			null,
			isPatientVerified,
			selectedDeliverRxIds,
			deliveryStockDisposition,
			deliveryStockSignature
		)
	}

	const requestStockDecisionOrProceed = (patientData, index) => {
		if (patientData?.instore_delivery_assignment?.assigned) {
			setPendingStockDecision({ patientData, index })
			setShowStockDecisionModal(true)
			return
		}

		processDelivery(patientData, index)
	}

	const handlePharmacistConfirmationCancel = () => {
		setShowPharmacistConfirmation(false);
		setPharmacistSignature(null);
		setPendingDeliveryData(null);
		setPendingDeliveryIndex(null);
	}

	const handleStockDecision = (deliveryStockDisposition, deliveryStockSignature = null) => {
		if (pendingStockDecision?.patientData && pendingStockDecision?.index !== null) {
			processDelivery(pendingStockDecision.patientData, pendingStockDecision.index, deliveryStockDisposition, deliveryStockSignature)
		}
		setShowStockDecisionModal(false)
		setPendingStockDecision(null)
	}

	const handleStockDecisionCancel = () => {
		setShowStockDecisionModal(false)
		setPendingStockDecision(null)
	}

	const handleRouteChange = async (e) => {
		const value = e.target.value

		if (value) {
			setSelectedRoute(value);
			setShowToast(true)

			setTimeout(() => {
				setShowToast(false)
			}, 2000);
		}

		const params = {
			route: value,
			pharmacy_id: pharmacyId,
			setLoading: setLoading,
		}

		if (value) {
			dispatch(clearAllTodayDispenseData())
			dispatch(todayDispenseRemovingPageNumber())
			setLoading(true)
			dispatch(fetchPatientlistOnBasisOfRoute(params));
		}
	}

	const fetchMoreData = () => {
		if (patientDataBasisOfRouteResponse?.currentPage < patientDataBasisOfRouteResponse?.totalPages) {
			setLoadMore(true)
			if (selectedRoute && pharmacyId) {
				const params = {
					route: selectedRoute,
					pharmacy_id: pharmacyId,
					page: patientDataBasisOfRouteResponse?.currentPage + 1,
					setLoadMore: setLoadMore
				}
				setLoading(false)
				dispatch(fetchPatientlistOnBasisOfRoute(params))
			}
		}
	}

	return (
		<>
			{patientDataBasisOfRouteResponse?.data?.length > 0 &&
				<InfiniteScroll
					dataLength={patientDataBasisOfRouteResponse?.data?.length}
					next={fetchMoreData}
					hasMore={patientDataBasisOfRouteResponse?.currentPage <= patientDataBasisOfRouteResponse?.totalPages}
				/>
			}

			<div className="app-wrapper flex justify-center">
				{/* <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden "> */}
				{/* <div className="app-screen no-shades w-full  lg:w-full md:w-6/12 sm:w-6/12 h-full  overflow-x-hidden "> */}
				<div className="app-screen no-shades w-full h-full  overflow-x-hidden ">

					<div className="relative p-4">

						<div className="card bg-white p-4 rounded-lg shadow-sm">
							<div className="flex items-center justify-between gap-3">

								<div>
									<Common.TopBar pharmacyId={pharmacyId} />
								</div>

								<div className='flex items-center justify-center btnnn pt-4' onClick={() => setShowConfirmationModal(true)} >
									<Icons.HomeIcon />
								</div>
							</div>

						</div>

						

						

						<div className="flex gap-3 mb-3">
							<SearchBox pharmacyId={pharmacyId} />
						</div>

						<RoutePharmacistModal
							handleRouteChange={handleRouteChange}
							showModel={showModel}
							setShowModel={setShowModel}
							selectedRoute={selectedRoute}
							placeholder='Select Route'
							isDelivered={false} route={selectedRoute} />

						<div className="routes-list">

							{(patientDataBasisOfRouteResponse?.loading && loading) ?

								<div className='flex justify-center pb-4 h-96'>
									<LoadingView />
								</div>

								: !selectedRoute ?

									<p className="flex justify-center pb-4 h-96 text-gray-500">
										Oops! It looks like no route was found. Please select a route.
									</p> :

									patientDataBasisOfRouteResponse?.error !== null ?

										<div className='flex items-center justify-center pb-4 mb-4 h-96'>
											<ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
										</div> :

										(todaysDispenseList?.length === 0 && !patientDataBasisOfRouteResponse?.loading) ?

											<p className='flex justify-center pb-4 h-96'>
												All Deliveries Done for this Route.
											</p> :

											todaysDispenseList?.map((data, index) => {
												const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
												return (
												<React.Fragment key={index}>
													<div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
														<PatientDetails
															data={data}
															patientImg={data.profile_image}
															totalRxData={data?.patients_win_rx_data?.length}
															index={index}
															openIndex={openIndex}
															onDropdownToggle={handleDropdownToggle}
															headerAction={<InstoreUnassignedHandover patient={data} selectedRxIds={selectedDeliverRxIds} isActive={openIndex === index} />}
														>
															<>
																<InstoreDeliveryAssignmentAlert assignment={data?.instore_delivery_assignment} />
																<DispenseRxData
																	newRxCounsellingValues={newRxCounsellingValues}
																	setNewRxCounsellingValues={setNewRxCounsellingValues}
																	rxData={data?.patients_win_rx_data}
																	patientData={data}
																	selectedDoses={selectedDoses}
																	setSelectedDoses={setSelectedDoses}
																	type="new_rx"
																	flexiProofImages={flexiProofImages}
																	setFlexiProofImages={setFlexiProofImages}
																	copayPaymentOptions={copayPaymentOptions}
																	setCopayPaymentOptions={setCopayPaymentOptions}
																	selectedDeliverRxIds={selectedDeliverRxIds}
																	setSelectedDeliverRxIds={setSelectedDeliverRxIds}
																	isActiveDeliverRxCard={openIndex === index}
																/>

																{patientId !== data?.id ? <>
																	<PharmacistSelection
																		signatureErrors={signatureErrors}
																		setSignatureErrors={setSignatureErrors}
																		setShowData={setShowData}
																	/>
																	{showData &&
																		<React.Fragment>
																			<div className="mb-3">
																				<Common.DeliveryConsultationDropdown consultation={consultation}
																					setConsultation={setConsultation} />
																			</div>
																				<div className="flex flex-col md:flex-row gap-3 mb-3 items-start">
																				<Common.PatientSignature
																					patientSignature={patientSignature}
																					setPatientSignature={setPatientSignature}
																					showPatientSignature={showPatientSignature}
																					setShowPatientSignature={setShowPatientSignature}
																					isRefused={isRefused}
																					setIsRefused={setIsRefused}
																					signatureErrors={signatureErrors}
																					setSignatureErrors={setSignatureErrors}
																					covid19={covid19}
																					setCovid19={setCovid19}
																					rxData={data?.patients_win_rx_data}
																				/>
																				<Common.PharmacistSignature
																					pharmacistSignature={pharmacistSignature}
																					setPharmacistSignature={setPharmacistSignature}
																					showPharmacistSignature={showPharmacistSignature}
																					setShowPharmacistSignature={setShowPharmacistSignature}
																					signatureErrors={signatureErrors}
																					setSignatureErrors={setSignatureErrors}
																					selectedPharmacistID={selectedPharmacistID}
																					pharmacistDetail={pharmacistDetail}
																				/>
																			</div>
																			<Common.Comment
																				showComment={showComment}
																				setShowComment={setShowComment}
																				setComment={setComment} comment={comment} />
																			<Common.PatientVerified
																				isPatientVerified={isPatientVerified}
																				setIsPatientVerified={setIsPatientVerified}
																			/>
																		</React.Fragment>
																	}

																	{selectedPharmacistID && (
																	<div className="flex items-center gap-3">
																		{showData ?
																			validateReturnedPatchesResponse?.loading ? null :
																				showFlexiConfirmation ? (
																					<button
																						className="px-4 flex-1 py-2 bg-[#10b981] text-white rounded-md"
																						onClick={() => window.location.reload()}
																					>
																						Reload
																					</button>
																				) : (
																					<button
																						className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white'}`}
																						style={noRxSelected ? undefined : { backgroundColor: '#10b981' }}
																						disabled={noRxSelected}
																						onClick={() => {
																							if (noRxSelected) return;
																							handleConfirmDelivery(data, index);
																						}}>
																						Continue
																					</button>
																				)
																			:
																			<button
																				className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white'}`}
																				style={noRxSelected ? undefined : { backgroundColor: '#10b981' }}
																				disabled={noRxSelected}
																				onClick={() => {
																					if (noRxSelected) return;
																					setShowData(true);
																					setTimeout(() => {
																						const windowHeight = window.innerHeight;
																						const scrollAmount = windowHeight / 2;
																						window.scrollBy({ top: scrollAmount, behavior: "smooth" });
																					}, 100);
																				}}
																			>
																				Deliver
																			</button>}
																	</div>
																	)} </> : null}
															</>
														</PatientDetails>
													</div>
												</React.Fragment>);
											})}
						</div>

						{loadMore &&
							<div className='flex mb-2'>
								<div className="loaderss"></div>
							</div>}

					</div>
				</div>
			</div>

			{showErrorToast && <DeliveryErrorMessages setShowErrorToast={setShowErrorToast} message={typeof showErrorToast === 'string' ? showErrorToast : undefined} />}
			{showSuccessToast && <DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}

			{showConfirmationModal &&
				<RouteConfirmation setShowConfirmationModal={setShowConfirmationModal}
					showConfirmationModal={showConfirmationModal}
					pharmacyId={pharmacyId} />
			}

		<PharmacistConfirmationModal
			showModal={showPharmacistConfirmation}
			setShowModal={setShowPharmacistConfirmation}
			pharmacistName={getSelectedPharmacistName()}
			onConfirm={proceedWithDelivery}
			onCancel={handlePharmacistConfirmationCancel}
		/>

		<InstoreDeliveryStockDecisionModal
			showModal={showStockDecisionModal}
			patientName={[pendingStockDecision?.patientData?.first_name, pendingStockDecision?.patientData?.last_name].filter(Boolean).join(' ')}
			signingAsName={getSelectedPharmacistName()}
			onTakeNow={(signature) => handleStockDecision('take_now', signature)}
			onReturnEndOfDay={() => handleStockDecision('return_end_of_day')}
			onCancel={handleStockDecisionCancel}
		/>

		<TodayDispenseDeliveredByAnotherDriverAblyHelper
				apiKey={apiKey}
				deliveryDriverDeliveredDispense={deliveryDriverDeliveredDispense}
				pharmacyId={pharmacyId}
				driverID={driverID}
				pId={pId}
				routeName={routeName}
				location={location}
				setPatientID={setPatientID}
				setDeliveryDoneByAnotherDriver={setDeliveryDoneByAnotherDriver}
				dispatch={dispatch}
				removeTodayDispenePatientById={removeTodayDispenePatientById}
				setOpenIndex={setOpenIndex}
				setPId={setPId}
				setCordinate={setCordinate}
			/>

		</>
	)
}

export default TodayDispense
